/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";
import { PageBase } from "../../../Components/PageBase";
import "./Facturacion.css"
import img from "../../../icons/avatar.png";
import img2 from "../../../icons/cash-sharp.svg";
import img3 from "../../../icons/ios-close-circle-outline.svg";
import { useRol } from "../../../Context";
import { DateTime } from 'luxon';

function Facturacion() {

    const { facturacion } = useRol();
    let fechaOriginal = 'Sin fecha de termino';

    const endDate = facturacion[0].end_date;
    if (facturacion.length > 0) {

        if (endDate && endDate !== "") {
            fechaOriginal = endDate;

            const fechaObjeto = new Date(fechaOriginal);
            const nombresMeses = [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ];
            const dia = fechaObjeto.getDate();
            const mes = fechaObjeto.getMonth();
            const año = fechaObjeto.getFullYear();
            const fechaFormateada = `${dia} de ${nombresMeses[mes]} de ${año}`;
            fechaOriginal = fechaFormateada;
        }
    }

    const fecha = fechaOriginal;
    const fechaActualSLP = DateTime.now().setZone('America/Mexico_City');
    const fechaLicencia = DateTime.fromISO(endDate);
    const licenciaVencida = fechaLicencia < fechaActualSLP;

    const calcularColorFondoFacturacion = () => {
        if (licenciaVencida) {
            return { fondo: '#ffb822', color: '#212529' };
        } else {
            return { fondo: '#d4edda', color: '#155724' };
        }
    };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="facturacion-container">
                    <div className="facturacion-porlet-card">
                        <div className="facturacion-title">
                            <h2>Detalles de facturación</h2>
                        </div>
                        <div className="facturacion-info">
                            {facturacion.map((item, index) => (
                                <div key={index} className="facturacion-info-body">
                                    <div className="info-img-container">
                                        <div className="img-data">
                                            <img src={img} alt="avatar" />
                                        </div>
                                    </div>
                                    <div className="info-label-container">
                                        <div className="label-data">
                                            <h5>{item.period_license || 'Sin Licencia'}</h5>
                                            <p>{item.type_license || 'Sin Paquete'}</p>
                                        </div>
                                    </div>
                                    <div className="info-label-container">
                                        <div className="label-data">
                                            <h5>Fecha de corte</h5>
                                            <p>{fecha}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div className="facturacion-alert">
                                <div className="facturacion-alert-body" style={{
                                    background: calcularColorFondoFacturacion().fondo,
                                    color: calcularColorFondoFacturacion().color,
                                }}>
                                    <div className="container-alert-body">
                                        <div className="alert-body-img">
                                            {licenciaVencida ? (
                                                <img src={img3} alt="cash" />
                                            ) : (
                                                <img src={img2} alt="cash" />
                                            )}
                                        </div>
                                        <div className="alert-body-p">
                                            {licenciaVencida ? (
                                                <p>Su licencia está vencida.</p>
                                            ) : (
                                                <p>Su licencia está activa.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="factura-movil">
                <div className="container-main-movil">
                    <div className="card-facturacion-movil">
                        <div className="card-facturacion-title-movil">
                            <label>Detalles de facturación</label>
                        </div>
                        {facturacion.map((item, index) => (
                            <div key={index} className="data-facturacion-movil">
                                <label>{item.period_license || 'Sin Licencia'}</label>
                                <span>{item.type_license || 'Sin Paquete'}</span>
                                <label>Fecha de corte</label>
                                <span>{fecha}</span>
                            </div>
                        ))}
                        <div className="status-licencia-facturacion-movil">
                            <img src={img2} alt="cash-sharp" />
                            <label>Su licencia esta activa</label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export { Facturacion }